
import React from 'react';
import MetricCard from '../MetricCard';

interface ClosedDealsCardProps {
  closedDealsCount: number;
  timeFrame?: string;
  noData?: boolean;
}

const ClosedDealsCard: React.FC<ClosedDealsCardProps> = ({ 
  closedDealsCount, 
  timeFrame = 'Past 30 days',
  noData = false
}) => {
  return (
    <MetricCard 
      title="Sales Won" 
      value={closedDealsCount.toString()} 
      tooltip={`Sales won (${timeFrame})`}
      min={0} 
      max={6} 
      current={closedDealsCount} 
      hideMinLabel={true}
      noData={noData}
    />
  );
};

export default ClosedDealsCard;
